import { DocumentData } from "@king-ict/eupisi-ui/models";

import { TownCodeBook } from "../../models/Town";

export interface OtherLegalEntityLocation {
  id: number;
  name: string;
  programExecutionRequestDocument?: DocumentData;
  ministryConsentDocument?: DocumentData;
  personnelConditionsDocument?: DocumentData
  address: string;
  town?: TownCodeBook;
  dateFrom: Date;
  dateTo: Date;
}

export function createOtherLegalEntityLocation(): OtherLegalEntityLocation {
  return { 
    id: 0,
    address: "", 
    name: "",
    dateFrom: new Date(),
    dateTo: new Date(),
  };
}